import * as React from "react";
import { IArticlePriceProps, PriceEnum } from "../../../../types/article-price";
import { useL10nContext } from "../../../../util/contexts";
import * as Detect from "../../../../util/contextDetection";
import "./article-price.scss";

const ArticlePrice = (props: IArticlePriceProps) => {
    const { decodePriceL10n } = useL10nContext();
    const priceL10n = decodePriceL10n();

    const isPriceTypeFrom = props.prices.minimalPrice.priceType === PriceEnum.From;
    const isScalePrice = props.prices.minimalPrice.quantity > 1;
    const isWebShop = Detect.isWebShop();

    const currencySymbol = isWebShop
        ? props.priceSettings.currencySymbolWeb
        : props.priceSettings.currencySymbolMobile;
    const preprendCurrencySymbol = isWebShop
        ? props.priceSettings.prependCurrencySymbolWeb
        : props.priceSettings.prependCurrencySymbolMobile;

    const quantityString = `${priceL10n.priceFromLocale} ${props.prices.minimalPrice.quantity} ${props.prices.quantityUnitPlural}`;

    const priceString = (priceValue: string): string => {
        const formattedPrice = preprendCurrencySymbol
            ? `${currencySymbol} ${priceValue}`
            : `${priceValue} ${currencySymbol}`;
        return isPriceTypeFrom ? `${priceL10n.priceFromLocale} ${formattedPrice}` : formattedPrice;
    };

    const comparisonPrice = (priceValue: string): string => {
        const formattedPrice = preprendCurrencySymbol
            ? `${currencySymbol} ${priceValue}`
            : `${priceValue} ${currencySymbol}`;
        return `${formattedPrice}/${props.prices.comparisonPrice!.unit}`;
    };

    return (
        <div className={"article-price"}>
            <div className={"price-info"}>
                <div>
                    {props.prices.discountPrice && (
                        <>
                            <div className="strike-price net">
                                <span className="value">
                                    {priceString(props.prices.discountPrice.originalPrice.netValue)}
                                </span>
                            </div>
                            <div className="strike-price gross">
                                <span className="value">
                                    {priceString(
                                        props.prices.discountPrice.originalPrice.grossValue
                                    )}
                                </span>
                            </div>
                            &nbsp;
                        </>
                    )}
                    <div
                        className={
                            "price" + `${props.prices.discountPrice ? " discounted" : ""}` + " net"
                        }
                    >
                        <span className="value">
                            {priceString(props.prices.minimalPrice.price.netValue)}
                        </span>
                    </div>
                    <div
                        className={
                            "price" +
                            `${props.prices.discountPrice ? " discounted" : ""}` +
                            " gross"
                        }
                    >
                        <span className="value">
                            {priceString(props.prices.minimalPrice.price.grossValue)}
                        </span>
                    </div>
                </div>

                {props.prices.comparisonPrice && (
                    <>
                        <div className="comparison-price net">
                            <span className="price-prefix">
                                {priceL10n.comparisonPrice}
                                {priceL10n.colon}{" "}
                            </span>
                            <span className="value">
                                {comparisonPrice(props.prices.comparisonPrice.price.netValue)}
                            </span>
                        </div>
                        <div className="comparison-price gross">
                            <span className="price-prefix">
                                {priceL10n.comparisonPrice}
                                {priceL10n.colon}{" "}
                            </span>
                            <span className="value">
                                {comparisonPrice(props.prices.comparisonPrice.price.grossValue)}
                            </span>
                        </div>
                    </>
                )}
            </div>

            <div className={"vat-info"}>
                <span className="price-mode net">({priceL10n.exVATAcronym})</span>
                <span className="price-mode gross">({priceL10n.incVATAcronym})</span>
                {isScalePrice && <span className="quantity">&nbsp;{quantityString}</span>}
            </div>
        </div>
    );
};

export default ArticlePrice;
